export default __webpack_public_path__ + "static/media/1045.07244a19.png";